import { GET_CUSTOM_FIELD_DEFINITIONS_QUERY } from "@/graphql";
import { useAppDispatch } from "@/redux-hooks";
import { useLazyQuery } from "@apollo/client/react";
import {
  setLoading,
  setCustomFieldDefinitions,
} from "@/custom-fields/custom-fields-slice";
import { useCallback } from "react";

export function useFetchCustomFields(): FetchCustomFields {
  const dispatch = useAppDispatch();
  const [fetchCustomFields] = useLazyQuery(GET_CUSTOM_FIELD_DEFINITIONS_QUERY);

  return useCallback(async () => {
    dispatch(setLoading(true));
    const { data } = await fetchCustomFields();

    if (data == null) return;

    dispatch(setCustomFieldDefinitions(data.customFieldDefinitions));
    dispatch(setLoading(false));
  }, [dispatch, fetchCustomFields]);
}

export type FetchCustomFields = () => Promise<void>;
